import * as React from 'react'
import * as cn from 'classnames'
import * as styles from './EntitlementCue.module.scss'
import { EntitlementCueObject, EntitlementCueTooltip } from '@utils'
import { Tooltip } from '@amzn/dvui/dist/Tooltip';

export interface EntitlementCueProps extends EntitlementCueObject {
    // Used for situations where the active card needs the cue to have a higher z index than non-active cards
    // e.g when the cue should stack on top of a Draper preroll
    increaseZIndex?: boolean
    hoverIsExpanded: boolean
    tooltipPositionOverride?: 'left' | 'right'
    containerRef?: React.RefObject<HTMLElement>
}

interface EntitlementCueTooltipProps extends EntitlementCueTooltip {
    imageClassName?: string
}

export const EntitlementCue = (props: EntitlementCueProps) => {
    const cueImage = <img
        className={cn(styles.cueImage, {[styles.increaseZIndex]: props.increaseZIndex})}
        src={props.cueImage}
        alt={props.accessibilityText}
    />

    return <div className={cn(styles.cueContainer, {
            [styles.increaseZIndex]: props.increaseZIndex,
            [styles.hoverIsExpanded]: props.hoverIsExpanded
        })}>
        {props.tooltip ? <Tooltip
            position={props.tooltipPositionOverride || 'top'}
            size={'m'}
            content={<TooltipContent {...props.tooltip} imageClassName={styles.tooltipImage}/>}
            containerRef={props.containerRef}
            className={styles.tooltip}
        >
            {cueImage}
        </Tooltip> : cueImage}
    </div>

}

const TooltipContent = (props: EntitlementCueTooltipProps) => {
    if (!props.image || !props.text.includes('{cueImage}')) return <>{props.text}</>
    const [before, after] = props.text.split('{cueImage}')
    return <span>{before}<img src={props.image} className={props.imageClassName}/>{after}</span>
}